import { ReactNode } from 'react';

type DropdownProps = {
  isVisible: boolean;
  title: string;
  onClickHandler: (event: React.MouseEvent) => void;
  children: ReactNode;
  className?: string;
}


const Dropdown = (props: DropdownProps) => {
  return (
    <li className={`nav-item dropdown ${props.className || ''}`}>
      <a className="nav-link" href="/#" onClick={props.onClickHandler}>
        {props.title}
      </a>
      {props.isVisible && (
        <ul className={`dropdown-menu ${props.isVisible ? 'show' : ''}`}>
          {props.children}
        </ul>
      )}
    </li>
  );
};

export default Dropdown;
